<template>
  <footer>
    <transition name="fade-in-bottom" appear>
      <div v-show="showFooter" class="content-wrapper">
        <div>
          <!-- <router-link :to="`/terms`"><p class="policies">Terms and Conditions</p></router-link>
          <span>|</span>-->
          <router-link :to="`/terms`">
            <p class="policies">Cancellation Policy</p>
          </router-link>
          <!-- <span>|</span>
          <router-link :to="`/terms`"><p class="policies">Privacy Policies</p></router-link>-->
        </div>
        <div>
          <p>© BCO Congresos {{(new Date()).getFullYear()}}</p>
        </div>
      </div>
    </transition>
  </footer>
</template>

<script>
export default {
  name: "LegalFooter",
  props: {
    showFooter: Boolean
  }
};
</script>

<style lang="scss" scoped>
footer {
  height: 60px;

  .content-wrapper {
    background: rgba(233, 233, 233, 0.3);
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
  }

  p {
    color: $secondary-black;
    font-family: "Source Sans Pro";
    font-size: 14px;
    letter-spacing: 0;
    text-align: right;
    line-height: 14px;
    display: inline-block;
    opacity: 1;

    &.policies:hover {
      text-decoration: underline;
    }
  }

  span {
    margin: 0 17px;
    color: #a8a8a8;
  }
}

// Animations

@media (min-width: 768px) {
  .fade-in-bottom-enter-active {
    opacity: 0;
    animation: fade-in-bottom-in 0.5s forwards;
    animation-delay: 0.4s;
  }

  @keyframes fade-in-bottom-in {
    from {
      transform: translateY(300px);
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
</style>
